<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M0 10C0 1 1 0 10 0s10 1 10 10-1 10-10 10S0 19 0 10z"/></svg>